import { render, staticRenderFns } from "./employee-fnnchis.vue?vue&type=template&id=5f20cac3&scoped=true&"
import script from "./employee-fnnchis.vue?vue&type=script&lang=js&"
export * from "./employee-fnnchis.vue?vue&type=script&lang=js&"
import style0 from "./employee-fnnchis.vue?vue&type=style&index=0&id=5f20cac3&prod&scoped=true&lang=css&"
import style1 from "./employee-fnnchis.vue?vue&type=style&index=1&id=5f20cac3&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f20cac3",
  null
  
)

export default component.exports